import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";
import { ChevronLeft, ChevronRight, CalendarDays } from "lucide-react";

/** Returns YYYY-MM-DD for a local Date. */
export const dateKey = (d) => {
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

export const isSameDay = (a, b) => dateKey(a) === dateKey(b);

/**
 * Day navigation bar: « prev | calendar/date | next » + optional "Heute" jump.
 */
export default function DayNav({ date, onChange, testid = "day-nav" }) {
  const shift = (delta) => {
    const d = new Date(date);
    d.setDate(d.getDate() + delta);
    onChange(d);
  };
  const today = new Date();
  const isToday = isSameDay(date, today);
  const label = date.toLocaleDateString("de-DE", {
    weekday: "long", day: "2-digit", month: "2-digit", year: "numeric",
  });

  return (
    <div className="flex items-center gap-1.5 flex-wrap" data-testid={testid}>
      <Button size="icon" variant="outline" onClick={() => shift(-1)} aria-label="Vorheriger Tag" data-testid={`${testid}-prev`}>
        <ChevronLeft className="h-4 w-4" />
      </Button>
      <Popover>
        <PopoverTrigger asChild>
          <Button variant="outline" className="min-w-[200px] justify-start font-normal" data-testid={`${testid}-calendar-trigger`}>
            <CalendarDays className="h-4 w-4 mr-2 text-muted-foreground" />
            {label}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align="start">
          <Calendar
            mode="single"
            selected={date}
            onSelect={(d) => d && onChange(d)}
            initialFocus
          />
        </PopoverContent>
      </Popover>
      <Button size="icon" variant="outline" onClick={() => shift(1)} aria-label="Nächster Tag" data-testid={`${testid}-next`}>
        <ChevronRight className="h-4 w-4" />
      </Button>
      {!isToday && (
        <Button variant="ghost" size="sm" onClick={() => onChange(new Date())} data-testid={`${testid}-today`}>
          Heute
        </Button>
      )}
    </div>
  );
}
